import React from "react"
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CCOLinkText from "../../fundamentals/CCOLinkText";
import {buttonStyle} from "../../../common/constants/buttonStyle";
import CCOLinkable from "../../fundamentals/CCOLinkable";
import {useTranslation} from "react-i18next";

export enum CallToActionType {
    TEXT,
    BUTTON,
}

interface Props {
    item: any
    callToActionType?: CallToActionType
    callToActionCustomText?: string
    insideCardWithLink?: boolean
    onClick?: any
}

function TeaserCardCallToAction(props: Props) {
    const {t} = useTranslation();
    switch (props.callToActionType) {
        case CallToActionType.TEXT:
            return renderCallToActionText(props, t);
        case CallToActionType.BUTTON:
            return renderCallToActionButton(props, t);
        default:
            return null;
    }
}

function renderCallToActionText(props: Props, t: any) {
    return <CCOLinkText txt={props.callToActionCustomText || t('coo_learn_more')} hasFocusedStyle/>;
}

function renderCallToActionButton(props: Props, t: any) {
    const openInNewTab = props.item?.teaserTarget?.openInNewTab;
    const colorStyle = buttonStyle[props.item?.teaserSettings?.callToActionButtonColor] ||
                       buttonStyle['green'];
    const CTAButtonContent = (
        <Typography variant='ctaButton'>
            {props.callToActionCustomText || t('c014_default_call_to_action_text')}
        </Typography>
    );

    // If inside a card with a link, render a div that looks like a button instead of a linkable button
    if (props.insideCardWithLink) {
        return (
            <Box
                className='cta-button-div'
                sx={{
                    mb: 1,
                    ...colorStyle,
                    display: 'inline-flex',
                    padding: '6px 16px',
                    borderRadius: '999px',
                    cursor: 'pointer'
                }}
            >
                {CTAButtonContent}
            </Box>
        );
    }

    return <Button component={CCOLinkable}
                   target={props.item.teaserTarget} noLinkIcon openInTab={openInNewTab}
                   onClick={props.onClick}
                   variant='contained' sx={{mb: 1, ...colorStyle}}>
        {CTAButtonContent}
    </Button>
}

export default TeaserCardCallToAction
